<!--
================================================
Un composant qui affiche une ligne de tableau d'un TaskTimerecord

Ce composant est une copie du TimerecordTableLineComp.vue, créé lors du pivot en task tracking | @since v0.8.0 (enfant du TaskTimerecordListComp)


     * Ce composant gère la fonction 'continue task record'.

(visible sur http://localhost:8080/fr/cronocloud-inc/timeTracking)

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

  <!-- ------------------------------------------>
  <!--    Timerecord de type isTask            -->
  <!-- ------------------------------------------>
  <tr class="has-text-left TaskTimerecordTableLineComp"
      v-bind:class="[{ 'darkMode':themeToDisplay=='dark', 'readOnly':readOnly}, 'detailTr_'+timerecord.slug]">

    <!--- TaskName--------------------------------------------->
    <td class="taskNameTd px-2" v-bind:class="'TaskTimerecordTableLineComp detailTr_'+timerecord.slug">
            <span>

                <!--- Task TR initial import icon--------------------------------------------->
                <span v-if="timerecord.isProjectInitialImport"
                      v-bind:id="'initialImportTr_'+timerecord.slug" class="initialImport">
                    <font-awesome-icon :icon="['fas', 'hourglass-half']" class="icon"/>
                </span>

              <!--- Task TR normal icon --------------------------------------------->
                <div v-else-if="timerecord.timeOut!==null && timerecord.isProjectInitialImport != true && !readOnly"
                     v-bind:id="'continueTr_'+timerecord.slug" class="iconContinueTask"
                     v-bind:title="$t('continuerLePointage', {taskName:timerecord.taskName })"
                     v-on:click="continueTask(timerecord)">
                    <font-awesome-icon :icon="['fas', 'play']" class="icon"/>
                </div>

                <span v-else-if="timerecord.timeOut==null && !readOnly" class="iconCurrentTask is-hidden-touch ml-4">
                     <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                </span>

<!--               <span v-else class="noIconReadonly is-hidden-touch"></span>-->
              <!--TaskName------------------------------ ----------------------->

                <span class="taskName" v-bind:class="{'readOnly':readOnly}">

                      <span><a  v-on:click="openModalTrEdit(timerecord)">
                          <span v-if="timerecord.taskName == null" class="noDesc">
                            ({{ $t('sansDescription') }})
                          </span>
                          <span v-else>{{timerecord.taskName}}</span>
                        </a>
                      </span>


                       <div v-if="timerecord.project !== null" class="is-hidden-desktop project4Mobile">
                         <font-awesome-icon v-bind:style="{color:'#'+ timerecord.project.color}" class="icon "
                                            :icon="['far', 'folder-open']"/>
                          <span class="">{{ timerecord.project.name }}</span>
                    </div>

                </span>

                <span class="tag encours" v-if="timerecord.timeOut==null">{{ $t('encours...') }}</span>

            </span>
    </td>

    <!--- Projet--------------------------------------------->
    <td class="projectTd px-3 is-hidden-touch">
      <!--- Project--------------------------------------------->
      <span v-bind:title="$t('projet')" class="project">
                <span v-if="timerecord.project !== null">
                                <font-awesome-icon v-bind:style="{color:'#'+ timerecord.project.color}" class="icon"
                                                   :icon="['far', 'folder-open']"/>
                    <span v-bind:class="'project project-'+timerecord.project.slug">{{ timerecord.project.name }}</span>
                </span>
            </span>

      <!--- Client--------------------------------------------->
      <span v-bind:title="$t('client')" class="client">
                <span v-if="timerecord.project !== null && timerecord.project.client !== null">
                    <font-awesome-icon :icon="['fas', 'user-tie']" class="icon"/>
                    <span v-bind:class="'clientName client-'+timerecord.project.client.slug">{{ timerecord.project.client.name }}</span>
                </span>
            </span>
    </td>

    <!--- Durée--------------------------------------------->
    <td class="timesTd px-3 ">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('durée')" class="duration">
                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                <span v-if="timerecord.isProjectInitialImport" class="">{{ durationInHours }}</span>
                <span v-else class="">{{ duration }}</span>
            </span>

      <!-- Tags (affichage spécial dans la durée pour les touch uniquement)-->
      <span class="is-hidden-desktop">
        <span class="tags4Touch" v-if="timerecord.tags.length > 0">
             <span class=" has-text-grey-light ml-2"
                   :content="$tc('xTags',timerecord.tags.length) + ' : '+ displayTagsInline(timerecord,0)"
                   v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
             >
              <!-- {{timerecord.tags.length }}-->
               <span class="tagsContent has-text-grey-lighter "><font-awesome-icon class=" " :icon="['fas', 'tag']"/></span>
             </span>
        </span>
      </span>

      <span v-if="timerecord.isProjectInitialImport!=true" class="is-hidden-touch times is-size-7 is-block">
                <!--- TimeIn--------------------------------------------->
                <span v-if="timerecord.timeOut!==null"
                      v-bind:title="$t('dateDébut', {date: $moment(timerecord.timeIn).format('LLLL') })">
                   <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon is-size-7 mr-1 inconInOut in" />
                    <span class="time">{{ timeIn }}</span>
                </span>

        <!--- TimeOut--------------------------------------------->
                <span v-if="timerecord.timeOut!==null"
                      v-bind:title="$t('dateFin', {date: $moment(timerecord.timeOut).format('LLLL') })"
                      class="is-hidden-mobile">
                    <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon is-size-7 mr-1 inconInOut out" />
                    <span class="time">{{ timeOut }}</span>
                </span>

            </span>

    </td>


    <!--- Tags--------------------------------------------->
    <td class="tagTd  px-3 ">
      <!-- Tags (affichage complet pour la réso fullhd)-->
      <div class="fullTags tags mb-0 is-hidden-touch is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only" >
        <span v-if="timerecord.tags !== []" v-for="(tag,index) in timerecord.tags">
                            <tag-comp class="is-hidden-touch is-hidden-widescreen-only" v-bind:tag="tag" v-if="tag.isArchived!=true && (index+1) <= displayTrTagsIfBelowMaxLength(timerecord, tagsLengthCumulatedLimit).tagsToDisplayFully"></tag-comp>


                  <!-- affichage des autre tags sour forme de mention ex : "+2" (une seule fois dans la boucle, au 1er élément dépassant)-->
                   <span v-if=" index == (displayTrTagsIfBelowMaxLength(timerecord, tagsLengthCumulatedLimit).tagsToDisplayFully )"
                         class="tagPlus  has-background-white-ter has-text-weight-normal has-text-grey-light
is-hidden-touch "
                         :content="displayTagsInline(timerecord,displayTrTagsIfBelowMaxLength(timerecord, tagsLengthCumulatedLimit).tagsToDisplayFully)"
                         v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
                   >
                     +{{displayTrTagsIfBelowMaxLength(timerecord, tagsLengthCumulatedLimit).tagsToMention}}
                     <span class="is-size-7  is-inline" ><font-awesome-icon :icon="['fas', 'tag']"/></span>
                   </span>

                </span>

      </div>


      <!-- Tags (affichage simplifé en dessous de fullhd (desktop à widescreen))-->
      <div class="tagSumTd is-hidden-touch is-hidden-fullhd" v-if="timerecord.tags.length > 0">
        <div class="summaryTags tags">
             <span class="tagSummary has-background-white-ter has-text-weight-normal has-text-grey-light"
                   :content="$tc('xTags',timerecord.tags.length) + ' : '+ displayTagsInline(timerecord,0)"
                   v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
             >
                    {{timerecord.tags.length }}
                     <span class="is-size-7  is-inline" ><font-awesome-icon :icon="['fas', 'tag']"/></span>
                   </span>

        </div>
      </div>
    </td>


    <!--- user--------------------------------------------->
    <td v-if="showUser" class="userTd px-3 is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only">
      <trigram-comp :firstname="timerecord.user.firstname" :last-name="timerecord.user.name" :color="null"></trigram-comp>

      <span class="fullname">
        <span class="firstname">{{ timerecord.user.firstname }}</span>
        <span class="name">{{ timerecord.user.name }}</span>
      </span>
    </td>
    <!--- isBillable--------------------------------------------->
    <td class="isBillableTd px-1 is-hidden-touch">

            <span class="isBillable" v-if="timerecord.isBillable"
                  :content="$t('facturable')"
                  v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
            >
<!--                <span class="circle" v-bind:title="$t('facturable')">-->
                <span class="circle">
                    <font-awesome-icon class="icon" :icon="['fas', 'dollar-sign']"/>
                </span>
            </span>

    </td>

    <!--- Icon edition--------------------------------------------->
    <td class="trEdit pl-1 pr-3 is-hidden-mobile" v-bind:class="'tr_'+ timerecord.slug" v-if="!readOnly">
      <a  v-on:click="openModalTrEdit(timerecord)"
         v-bind:title="$t('modifierLePointage')" class="editIcon is-pulled-right">
        <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>

      </a>
    </td>

  </tr>


</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import TimeMixin from "../mixins/TimeMixin.js";
import TrigramComp from "@/components/TrigramComp";
import TagComp from "@/components/Tags/TagComp";
import TagMixin from "@/mixins/TagMixin";

export default {
  name: 'TaskTimerecordTableLineComp',
  components: {TagComp, TrigramComp},
 //utile dans vue dev tool
  mixins: [TimeMixin, TagMixin],
  // components: {},
  // props: ['timerecord'],
  props: {
    timerecord : Object, // un objet timerecord
    readOnly: Boolean, // si vaut true les boutons continuer et liens d'édition sont masqués
    showUser: {
      type: Boolean, // si vaut true la ligne affichera le nom complet du créateur du timerecord
      required: false,
      default: false,
    }
  },

  data: function () {
    return {

      locale: this.$route.params.locale,

      tagsLengthCumulatedLimit: 16, // int la limit de nombre de caractères cumulés à afficher pour les tags @see displayTrTagsIfBelowMaxLength

      // pour les composants où l'user est identifié ///////////////////////
      // organizationSlug: this.$route.params.organization
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug)
      // componentIsReady : false, // indique quand le composant est prêt à être afficher
      // =================================================================
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      currentTaskTr: state => state.TimeTrackingView.currentTaskTimerecord,
      themeToDisplay: state => state.app.themeToDisplay

    }),


    timeIn: {
      get: function () {
        return this.$moment(this.timerecord.timeIn).tz(this.user.timezone).format('LT')
      },
    },
    timeOut: {
      get: function () {
        return this.$moment(this.timerecord.timeOut).tz(this.user.timezone).format('LT')
      },
    },

    duration: {
      get: function () {
        let duration = this.calculateDuration(this.$moment, this.timerecord.timeIn, this.timerecord.timeOut)

        return this.formatDuration(duration, this.$moment, this.locale)
      },
    },

    durationInHours: {
      get: function () {
        let duration = this.calculateDuration(this.$moment, this.timerecord.timeIn, this.timerecord.timeOut)
        return this.formatDurationInHour(duration, this.$moment, this.locale)
      },
    }


  },


  methods: {
    /**
     * Ouvre la Modal d'édition d'un task timerecord et prépare le timerecord dans le store
     * @param timerecord
     */
    openModalTrEdit: function (timerecord) {
      let isCurrent = false; // indique si le timerecord est en cours (timeout = null)
      if (timerecord.timeOut == null) {
        isCurrent = true
      } else {
        isCurrent = false
      }

      this.$store.commit('UpdateModalTaskTimerecordsEditionComp', {
        isVisible: true,
        timerecord: timerecord,
        isCurrent: isCurrent
      })

    },

    /**
     * Déclenche l'event "continue_task_event"
     * Permet de démarrer un task tr depuis le NewTaskComp
     **/
    sendContinueTaskEvent: function (timerecord) {
      this.$root.$emit('continue_task_event', timerecord)
    },


    /**
     * Déclenche l'event "stop_current_task"
     * Permet de stopper le current task tr (dans CurrentTaskComp) avant d'un démarrer un nouveau
     **/
    sendStopCurrentTaskEvent: function () {
      this.$root.$emit('stop_current_task')
    },


    /**
     * Déclenche la duplication d'une tâche au clic sur  le bouton .iconContinueTask
     * @param timerecord
     */
    continueTask: function (timerecord) {


      // On vérifie si une task timerecord est en cours
      if (this.currentTaskTr != null) { // si un current task tr..

        // via sendStopCurrentTaskEvent on va mettre à jour le store pour que le tr stoppé soit mis à jour dans TaskTimerecordListComp et n'affiche plus "en cours"
        this.sendStopCurrentTaskEvent(timerecord);

        // on définit un timeOut afin que 'encours' se masque de la ligne du tableau
        this.timerecord.timeOut = this.$moment().format('Y-MM-DD HH:mm:ss');

        // on vide le currentTask du store (afin que le CurrentTaskComp face place au NewTaskComp)
        this.$store.commit('UpdateTimeTrackingViewCurrentTask', null);

        let self = this;
        setTimeout(function () {
          self.sendContinueTaskEvent(timerecord);

        }, 200) // ici j'ai dû décaler le déclenchement de 200ms pour que cela fonctionne.

      } else {
        this.sendContinueTaskEvent(timerecord);

      }


    },


    /**
     * Affiche les tags d'un timerecord uniquement de manière à ne pas dépasser le nombre limit de caractères.
     * Les tags au dela de la limite sont affichés sous formes d'un compteur
     *
     * Par exemple : Si timerecord possède 3 tags : "alpha", "bravo","echo" et que carLimit vaut 10 alors on affichera les tags sous la forme : "alpha bravo (+1)"
     *
     * @param timerecord | Un object Timerecord
     * @param carLimit | Le nombre de caractère au délà duquel on affiche plus les tags
     */
    displayTrTagsIfBelowMaxLength: function (timerecord, carLimit) {

      // on créé une tagsToDisplayFully qui servira à incrémenter le nombre de tags à afficher sous leur form complète
      let tagsToDisplayFully = 0
      let cumulatedLength = 0 // la longeur de tags cumulés (dans la boucle)

      // on créé une tagsToMention qui servira à incrémenter le nombre de tags à mentionner sou forme de +
      let tagsToMention = 0

      // on boucle sur tous les tags du timerecord
      // on calcul la longeur du tag
      timerecord.tags.forEach(function (tag, index) {
        if (tag.name != null && (cumulatedLength + tag.name.length) < carLimit) { // si on n'a pas déjà atteint la limite total de caractère on teste la longeur du tag en cours dans la boucle
          cumulatedLength = cumulatedLength + tag.name.length
          tagsToDisplayFully++
        } else {
          tagsToMention++
        }
      })
      return {tagsToDisplayFully: tagsToDisplayFully, tagsToMention: tagsToMention}

    },


  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->
.trigram{background-color: #0beabc !important;}

<!-- Css non scopé pour surcharger d'autres composants-->
<style lang="scss" >
@import "../assets/css/globalVar.scss";

.userTd{
  .trigram{
    background-color: $superLightBlue !important;
    .letters{color: $brandThird !important;}
  }
}
.darkMode {
  .userTd{
    .trigram{
      background-color: $darkBg !important;
      .letters{color: $darkTxt !important;}
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/globalVar.scss";
@import "../assets/css/bulmaResponsiveDep.scss";

.TaskTimerecordTableLineComp {

  .taskNameTd {
    //position: relative;
    // gestion de la taille pour que tous soit à peu prés visible selon la résolution
    @include tablet { min-width: $variableTxtMinWidth + 1rem; max-width: $variableTxtMinWidth + 2rem }
    @include desktop { min-width: $variableTxtMinWidth + 1rem; max-width: $variableTxtMinWidth + 2rem }
    @include widescreen { min-width: $variableTxtMinWidth + 1rem;}
    //border: dashed 1px yellow !important;


  }

  //.icon{
  //    padding-top: 8px; // corrige alignement vertical
  //}
  .time {
    /*font-weight: bold;*/
    color: #999;
    margin-right: 0.5rem;

  }

  .icon {
    margin-right: .2rem;
    /*border: darkgrey solid 1px;*/
    vertical-align: center;
    padding-top: 0;
    $size: 0.9rem;
    width: $size;
    height: $size;
  }

  .iconContinueTask {
    $size: 2.3rem;
    width: $size;
    height: $size;
    padding: 0.5rem;
    border-radius: 3rem;
    margin-left: 0.5rem;
    cursor: pointer;
    border: solid 1px #ccc;
    transition: border-color 200ms ease-in;
    display: inline-block;

    &:hover {
      border: solid 1px $brandPrimary;

      .icon {
        color: darken($brandPrimary, 5%);
      }
    }

    &:active {
      box-shadow: 0 0 3px $brandPrimary;

      .icon {
        color: darken($brandPrimary, 5%);
      }
    }

    .icon {
      height: 0.6rem;
      width: 0.6rem;
      /*margin: 0 0 0 0.1rem;*/
      position: relative;
      left: 0.3rem;
      top: -0.3rem;

      @include mobile{
        left: 0.3rem;
        top: -0.15rem;

      }

      /*width: 12px;*/
      color: #919290;
    }

  }

  $sizeIcon: 2.5rem;

  .taskName {
    color: $taskColor;
    font-weight: bold;
    padding-left:  1rem;
    //min-width: $variableTxtMinWidth * 2;
    //min-width: 30rem;
    //border: dashed 1px red;
    // limitation de la longeur d'affichage du nom de la  task
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @include desktop{ max-width:$variableTxtMinWidth}
    /*max-width: 3rem;*/
    @include mobile {
      max-width: $variableTxtMinWidth;
      font-size: 0.9rem;

    }

    .noDesc{
      color:#999 ;
    }
    a {
      color: $taskColor;


    }

    &.readOnly{
      a{ // en mode readOnly on désactive le cursor pointer sur la description du pointage
        cursor:default;
      }
    }

    &.isCurrentTask {
      color: $brandSecondary;
      margin-right: 1rem;
    }

    .project4Mobile {
      font-size: 0.7rem;
      font-weight: normal;
      color: #777;
      line-height: 0.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      //background: lightgreen;
      max-width: 10rem;
      @include mobile {

      }
    }


  }

  .inconInOut {

    display: inline-block;
    border: none;
    border-radius: 30px;
    vertical-align: center;
    color: #ddd !important;

    &.in {
    }

    &.out {
    }
  }

  .duration {

    //border-left: solid 1px #ccc;
    //padding-left: 1rem;
    //margin-right: 0.8rem;
    font-weight: bold;
    color: $brandThird;

    .icon {
      color: $brandFourth;
    }
  }

  .tagTd,.tagSumTd{
    .tagPlus,.tagSummary{
      border: solid 1px #eee;
      padding: .2rem .4rem ;
      font-size: .8rem;
      border-radius: 1rem;
      box-shadow: 0 0 2px #999;
      .icon{
      }
    }
  }
  .projectTd {
    // définir une taille mini à la case .projectTd permet d'harmoniser les tailles de toutes les lignes du tableau y compris lorsque le projet est vide
    @include tablet { min-width: $variableTxtMinWidth + 1rem; max-width: $variableTxtMinWidth + 2rem }
    @include desktop { min-width: $variableTxtMinWidth + 1rem; max-width: $variableTxtMinWidth + 2rem }

    .project {
      color: #777;
      font-weight: bold;
    }

    .client {
      color: #ccc;
      font-size: .75rem;
      display: block;

      .icon{
        margin-right:.3rem;
        vertical-align: baseline;
        height: .6rem; width: .6rem;
      }
    }

  }
  .timesTd{
    //min-width: $variableTxtMinWidth + 5rem;
    //border: dashed 1px greenyellow !important;
      .times{
        //@include tablet {display: none} // heure de début fin masquée sur tablet
      }

    .tags4Touch{

    }
  }

  .userTd {
    .fullname {
      display: inline-block;
      font-weight: bold;
      //background-color: hotpink !important;
    }
    .firstname {
      //display: inline-block;
      margin-right: .3rem;
      margin-left: .6rem;
      text-transform: capitalize;
    }
    .name{
      text-transform: uppercase;

    }

  }

  .isBillableTd {
    .isBillable {
      position: relative;
      @include tablet {display: none} //  masqué sur tablet
      @include desktop {display: block}


      //&:hover{cursor: help;}
      .circle {
        width: 2rem;
        height: 2rem;
        //position: absolute;
        //top: -0.3rem;

        //background: #e9f4ce;
        //border: solid 1px #e9f4ce;
        border-radius: 1.2rem;
        display: block;

        .icon {
          display: block;
          color: $brandPrimary;
          font-size: 1.2rem;
          margin: 0.5rem auto 0 0.45rem;
          /*background: #e9f4ce !important;*/
        }

      }
    }

  }

  .encours {
    color: #999;
    font-weight: bold;
    margin-left: 0.8rem;
    padding: 0.9rem 0.7rem;
    vertical-align: bottom;

    animation: blink 1s infinite alternate;
    @keyframes blink {
      from {opacity: .1;}
      to {opacity:1;}
    }
  }

  td.trEdit {
    padding: 0 2rem 0; // pour la case d'édition on reset le padding td bulma par défaut
    /*background: red;*/


    @include mobile {
      padding: 0 0.5rem;
    }

    .editIcon {

      display: block;
      $size: 2.1rem;

      width: $size;
      height: $size;
      border-radius: 2rem;
      background: lighten($brandFourth,39%);
      cursor: pointer;

      &:hover {
        .icon {
          color: darken($brandFourth,10%)
        }
      }

      &:active {
        .icon {
          color: $brandBlue
        }
      }

      .icon {
        margin-left: 0.6rem;
        margin-top: 0.5rem;
        color: lighten($brandFourth,5%);
        $size: 1rem;
        width: $size;
        height: $size;
        transition: color 100ms;

      }
    }

  }

  /////////////////////////////////
  ////////////// DARK UI
  &.darkMode {
    .iconContinueTask {
      border-color: $darkTableBorder;
      background: $darkBg3;

      &:hover {
        border: solid 1px $brandPrimary;

        .icon {
          color: darken($brandPrimary, 5%);
        }
      }

      &:active {
        box-shadow: 0 0 3px $brandPrimary;

        .icon {
          color: darken($brandPrimary, 5%);
        }
      }
    }

    .iconCurrentTask {
      margin-left: 1.4rem;
    }

    .taskName {
      color: $darkTxt;

      a {
        color: #f4f4f4
      }
      .noDesc{
        color:#666 ;
      }

      //&.isCurrentTask {
      //  color:red;
      //}
    }

    .inconInOut {
      color:lighten($darkBg2,10%) !important;
      &.in {}
      &.out {}
    }

    .duration {
      color: #ccc;
      border-color: #666
    }

    .icon {
      color: lighten($darkBg2,20%)
    }

    .projectTd {
      .project {
        color: #ccc
      }

      .client {
        color: #999
      }
    }
    .timesTd{
      .times{
        //@include tablet {display: none} // heure de début fin masquée sur tablet
      }

      .tags4Touch{
          .tagsContent{
            color:lighten($darkBg2,20%) !important;
          }
      }
    }


    .tagTd,.tagSumTd{
      .tagPlus,.tagSummary{
        border-color:#444;
        background-color: $darkBg3 !important;
        color: $darkTxt !important;

      }
    }

    .isBillable {
      .circle {
        color: $brandPrimary;
        border-color: transparent;
        //background: darken($brandPrimary,20%);
        background: transparent !important;

        .icon {
        }
      }
    }

    .encours {
      color: $darkLightBlue;
      background: $darkBg3
    }

    .editIcon {
      background: $darkBg3 !important;
      .icon {
        color: lighten($darkBg3,35%) !important
      }
      &:hover {
        .icon {
          color: lighten($darkBg3,55%) !important
        }
      }

      &:active {
        .icon {
          color: $brandPrimary !important
        }
      }
    }

  }
}
</style>
